import { Settings, TouristSite } from '../types';
import { getDistance, getTravelTime } from './circuitEngine';

export interface DistanceMatrix {
  [key: string]: { distance: number; duration: number };
}

/**
 * Service pour gérer la fusion des matrices de distances (Permanente + Temporaire)
 */
export const matrixService = {
  
  /**
   * Fusionne la matrice permanente (chauffeur + sites) avec la matrice temporaire (client + sites)
   */
  getMergedMatrix(permanentMatrix: DistanceMatrix, temporaryMatrix: DistanceMatrix): DistanceMatrix {
    return { ...permanentMatrix, ...temporaryMatrix };
  },

  /**
   * Calcule les distances pour un nouveau point (ex: adresse client) par rapport à tous les sites
   */
  async calculateTemporaryDistances(
    newPointLoc: { lat: number, lng: number },
    newPointId: string,
    sites: TouristSite[],
    settings: Settings
  ): Promise<DistanceMatrix> {
    const tempMatrix: DistanceMatrix = {};
    
    for (const site of sites) {
      const pairKey = [newPointId, site.id].sort().join('_');
      const dist = getDistance(newPointLoc, site.location, newPointId, site.id, settings);
      const duration = getTravelTime(dist, newPointId, site.id, settings);
      
      tempMatrix[pairKey] = { distance: dist, duration };
    }
    
    return tempMatrix;
  },

  async updateDriverHomeAndMatrix(
    newAddress: string,
    newLocation: { lat: number, lng: number },
    currentSettings: Settings,
    currentSites: TouristSite[],
    updateSettings: (newSettings: Settings) => void
  ) {
    const driverHomeDistances = await this.calculateTemporaryDistances(
      newLocation,
      'DRIVER_HOME',
      currentSites,
      currentSettings
    );
    const newMatrices = { ...(currentSettings.distanceMatrices || {}), ...driverHomeDistances };
    updateSettings({ ...currentSettings, driverHomeAddress: newAddress, distanceMatrices: newMatrices });
  }
};
